const scope = 'loop/ForgotPassword';

export const PASSWORD_RESET_REQUEST = `${scope}/PASSWORD_RESET_REQUEST`;
export const PASSWORD_RESET_REQUEST_SUCCESS = `${scope}/PASSWORD_RESET_REQUEST_SUCCESS`;
export const PASSWORD_RESET_REQUEST_ERROR = `${scope}/PASSWORD_RESET_REQUEST_ERROR`;

export const ENTER_PASSWORD = `${scope}/ENTER_PASSWORD`;
export const ENTER_PASSWORD_SUCCESS = `${scope}/ENTER_PASSWORD_SUCCESS`;
export const ENTER_PASSWORD_ERROR = `${scope}/ENTER_PASSWORD_ERROR`;

export const CHANGE_EMAIL = `${scope}/CHANGE_EMAIL`;

// Verify Password Attempt
export const VERIFY_PASSWORD_ATTEMPT_CHANGE = 'loop/Register/VERIFY_PASSWORD_ATTEMPT_CHANGE';
export const VERIFY_PASSWORD_ATTEMPT_CHANGE_SUCCESS = 'loop/Register/VERIFY_PASSWORD_ATTEMPT_CHANGE_SUCCESS';
export const VERIFY_PASSWORD_ATTEMPT_CHANGE_ERROR = 'loop/Register/VERIFY_PASSWORD_ATTEMPT_CHANGE_ERROR';


export const RESEND_CODE_PHONE = 'loop/Register/RESEND_CODE_PHONE';
export const RESEND_CODE_PHONE_SUCCESS = 'loop/Register/RESEND_CODE_PHONE_SUCCESS';
export const RESEND_CODE_PHONE_ERROR = 'loop/Register/RESEND_CODE_PHONE_ERROR';




